import React from 'react'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

interface RelatedExceptionListOverviewProps {
  data: any
}

export default function RelatedExceptionListOverview({ data }: RelatedExceptionListOverviewProps) {
  const theme = useTheme()

  const bankExceptions = data?.aals_00001 === 1 ? 1 : 0

  const onlineLendingFlags = [
    data?.aals_00011,
    data?.aals_00012,
    data?.aals_00013,
    data?.aals_00014,
    data?.aals_00015,
    data?.aals_00016,
  ]
  const onlineLendingExceptions = onlineLendingFlags.filter((flag) => flag === 1).length

  const normalBehaviorFlags = [
    data?.aals_00021,
    data?.aals_00022,
    data?.aals_00023,
    data?.aals_00024,
    data?.aals_00025,
    data?.aals_00026,
    data?.aals_00027,
  ]
  const normalBehaviorCount = normalBehaviorFlags.filter((flag) => flag === 1).length

  const seriousBehaviorFlags = [
    data?.aals_00031,
    data?.aals_00032,
    data?.aals_00033,
    data?.aals_00034,
    data?.aals_00035,
    data?.aals_00036,
    data?.aals_00037,
  ]
  const seriousBehaviorCount = seriousBehaviorFlags.filter((flag) => flag === 1).length

  const behaviorExceptions = normalBehaviorCount + seriousBehaviorCount

  const behaviorSubtitle =
    behaviorExceptions > 0 ? `普通${normalBehaviorCount}项 / 严重${seriousBehaviorCount}项` : '7项检测'

  return (
    <div className="mt-2">
      <Stack gap="md">
        <div className="flex flex-col gap-2">
          <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
            关联人异常概览
          </Text>
          <Text size="xs" className="text-gray-500">
            汇总关联人在银行、网贷机构的异常标记及异常行为检测结果,供风险审核参考。
          </Text>
        </div>
        <div className="grid gap-3 md:grid-cols-3">
          <SummaryItem label="银行异常标记" value={`${bankExceptions} 项`} subtitle="1项检测" />
          <SummaryItem label="网贷异常标记" value={`${onlineLendingExceptions} 项`} subtitle="6类机构" />
          <SummaryItem label="异常行为标记" value={`${behaviorExceptions} 项`} subtitle={behaviorSubtitle} />
        </div>
      </Stack>
    </div>
  )
}

interface SummaryItemProps {
  label: string
  value: string
  subtitle?: string
}

function SummaryItem({ label, value, subtitle }: SummaryItemProps) {
  const theme = useTheme()

  return (
    <div
      className="rounded-lg border px-4 py-3"
      style={{ borderColor: theme.surfaceBorderColor, backgroundColor: theme.surfaceColor }}
    >
      <Text size="xs" className="text-gray-500">
        {label}
      </Text>
      <Text size="sm" fw={600} style={{ marginTop: '6px', color: theme.primaryColor }}>
        {value}
      </Text>
      {subtitle && (
        <Text size="xs" className="text-gray-400" style={{ marginTop: '4px' }}>
          {subtitle}
        </Text>
      )}
    </div>
  )
}
